import { render, staticRenderFns } from "./activities2.vue?vue&type=template&id=1819ac9c"
import script from "./activities2.vue?vue&type=script&lang=js"
export * from "./activities2.vue?vue&type=script&lang=js"
import style0 from "./activities2.vue?vue&type=style&index=0&id=1819ac9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports